import { WidgetDefinition, WidgetTextStyle } from "./common";
import WidgetType from "../enum/WidgetType";
import Font from '../enum/Font';
import TextAlignment from "../enum/TextAlignment";
import PriceMode from '../enum/PriceMode';
import AssetContentMode from "../enum/AssetContentMode";
import ProductSubtitlePosition from "../enum/ProductSubtitlePosition";

const Product: WidgetDefinition = {

    type: WidgetType.PRODUCT,
    className: 'widget-product',
    contentComponent: 'dmb-widget-content-product',

    settingsSectionComponents: [
        'dmb-section-widget-settings-product',
        'dmb-section-widget-style',
        'dmb-section-widget-animation'
    ],

    defaultSize: {
        width: 0.4,
        height: 0.4
    },

    defaultStyle: {
        opacity: 100,
        padding: 10,
        contentMode: AssetContentMode.COVER
    },

    defaultSettings: (options) => ({
        showTitle: true,
        showSubtitle: true,
        showVariant: true,
        showPrice: true,
        showCurrency: true,
        showImage: true,
        imageSize: null,
        showLabels: true,
        showLabelImage: true,
        showLabelBackground: true,
        showLabelText: true,
        labelImageSize: 24,
        labelPosition: ProductSubtitlePosition.NEXT,
        priceMode: PriceMode.DECIMAL_COMMA,
        productId: options.isTemplate ? '0' : null,
        titleTextStyle: {
            font: Font.PRIMARY,
            size: 22,
            bold: true,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        subtitleTextStyle: {
            font: Font.PRIMARY,
            size: 18,
            color: 'FFFFFF',
            alignment: null,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        variantTextStyle: {
            font: Font.PRIMARY,
            size: 20,
            bold: true,
            color: 'FFFFFF',
            alignment: TextAlignment.LEFT,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        priceTextStyle: {
            font: Font.PRIMARY,
            size: 20,
            color: 'FFFFFF',
            alignment: null,
            bold: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle,
        labelTextStyle: {
            font: Font.PRIMARY,
            size: 14,
            bold: true,
            color: 'FFFFFF',
            alignment: null,
            borderColor: null,
            borderSize: null,
            characterSpacing: null,
            customFont: 'Arial',
            italic: null,
            lineSpacing: null,
            shadowBlur: null,
            shadowColor: null,
            shadowOffsetX: null,
            shadowOffsetY: null,
            transform: null,
            underlined: null
        } as WidgetTextStyle
    })
}

export default Product